/* APEXX · Buy Box — assets/apexx-buy-box.js
   Variant swatch selection → updates hidden id, price, button label, and the
   "Colour: X" caption. Works per-section instance and re-binds in the editor. */
(function () {
  function money(cents, fmt) {
    // fmt like "€{{amount}}" or with comma decimals; fall back to simple EUR.
    var v = (cents / 100);
    var s = v.toFixed(2);
    if (fmt && (fmt.indexOf('comma') > -1 || fmt.indexOf(',') > -1)) s = s.replace('.', ',');
    s = s.replace(/[.,]00$/, ''); // whole amounts show as 160, not 160,00
    return (fmt && fmt.indexOf('{{') > -1 && fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s)) || ('€' + s);
  }

  function bind(root) {
    (root || document).querySelectorAll('.apexx-bb').forEach(function (bb) {
      if (bb.dataset.bbBound) return;
      bb.dataset.bbBound = '1';

      var form = bb.querySelector('[data-bb-form]');
      var idInput = bb.querySelector('[data-bb-id]');
      var priceEls = bb.querySelectorAll('[data-bb-price]');
      var caption = bb.querySelector('[data-bb-chosen]');
      var btn = bb.querySelector('[data-bb-btn]');
      var fmt = bb.getAttribute('data-money') || '';
      var swatches = bb.querySelectorAll('.apexx-bb__swatch');

      // Live top price: selected variant + any paid lens upgrade (Core behaviour).
      var baseCents = parseInt(bb.getAttribute('data-base-cents'), 10) || 0;
      var photoSelected = null;
      var rxCents = 0;
      function updatePrices() {
        var extra = (photoSelected ? (parseInt(photoSelected.dataset.price, 10) || 0) : 0) + rxCents;
        if (baseCents) priceEls.forEach(function (el) { el.textContent = money(baseCents + extra, fmt); });
        // Trial "X today" figures include the lens — it charges in full today
        // even on the deposit plan (the plan only covers the bundle).
        var po = bb.querySelector('[data-bb-payopts]');
        if (po && !po.hasAttribute('data-preorder')) {
          var dep = parseInt(po.getAttribute('data-dep-cents'), 10) || 0;
          if (dep) {
            // Several places quote the deposit on a trial-only card (headline,
            // CTA, confirm step) — keep every one of them live, not just the first.
            bb.querySelectorAll('[data-bb-dep]').forEach(function (el) { el.textContent = money(dep + extra, fmt); });
            // Day-30 balance is the bundle alone: add-ons are charged in full today.
            if (baseCents) bb.querySelectorAll('[data-bb-balance]').forEach(function (el) { el.textContent = money(baseCents - dep, fmt); });
          }
          var planInputEl = bb.querySelector('[data-bb-selling-plan]');
          var subEl2 = btn && btn.querySelector('.apexx-bb__btn-sub');
          if (dep && planInputEl && !planInputEl.disabled && subEl2) {
            var tpl = po.getAttribute('data-plan-sub') || '';
            var lbl = po.getAttribute('data-deposit-label') || '';
            if (tpl && lbl) subEl2.textContent = tpl.replace(lbl, money(dep + extra, fmt));
          }
        }
      }
      function select(sw) {
        if (!sw || sw.disabled) return;
        swatches.forEach(function (s) { s.setAttribute('aria-pressed', s === sw ? 'true' : 'false'); });
        if (idInput) idInput.value = sw.dataset.variantId || idInput.value;
        if (caption) caption.textContent = sw.dataset.name || '';
        if (sw.dataset.cents) { baseCents = parseInt(sw.dataset.cents, 10) || baseCents; updatePrices(); }
        else if (sw.dataset.price) { priceEls.forEach(function (el) { el.textContent = sw.dataset.price; }); }
        // Show the variant's own photo (straps: red/blue/green/black). The
        // swatches bypass Dawn's variant picker, so the gallery has to be told.
        if (sw.dataset.mediaId) {
          var gallery = document.querySelector('media-gallery');
          var slide = gallery && gallery.querySelector('[data-media-id="' + sw.dataset.mediaId + '"]');
          if (slide && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(sw.dataset.mediaId, true);
          // "Hide other variants' media" leaves only the current variant's slide
          // in the page, so the others have nothing to switch to — the picture is
          // swapped in place instead. Done for the original variant too: once its
          // slide has shown another colour, re-activating it would not restore it.
          if (sw.dataset.image) {
            var hero = document.querySelector('.product__media-item.is-active img') || document.querySelector('.product__media-item img');
            if (hero) { hero.removeAttribute('srcset'); hero.src = sw.dataset.image; }
          }
        }
      }

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () { select(sw); });
      });

      // Stars under the title → jump to the full reviews section. The rating
      // row is display-only Klaviyo markup, so the affordance lives here.
      var ratingRow = bb.querySelector('.apexx-bb__rating');
      if (ratingRow && !ratingRow.dataset.bbRatingBound) {
        ratingRow.dataset.bbRatingBound = '1';
        ratingRow.style.cursor = 'pointer';
        ratingRow.setAttribute('role', 'link');
        ratingRow.setAttribute('tabindex', '0');
        ratingRow.setAttribute('aria-label', 'Read customer reviews');
        var goReviews = function () {
          var target = document.getElementById('fulfilled-reviews-all');
          if (!target) return;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (window.apexxTrack) apexxTrack('stars_tap', { handle: location.pathname.split('/').pop() });
        };
        ratingRow.addEventListener('click', goReviews);
        ratingRow.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goReviews(); }
        });
      }

      // "Need prescription lenses?" expander — one insert rides along as its
      // own full-price line, added via /cart/add.js alongside the bundle.
      var rxWrap = bb.querySelector('[data-bb-rx]');
      var rxSelected = null;
      if (rxWrap) {
        var rxToggle = rxWrap.querySelector('[data-bb-rx-toggle]');
        var rxModal = rxWrap.querySelector('[data-bb-rx-modal]');
        var rxLabel = rxWrap.querySelector('[data-bb-rx-meta-label]');
        var rxAdd = rxWrap.querySelector('[data-bb-rx-add]');
        var rxRemove = rxWrap.querySelector('[data-bb-rx-remove]');
        var rxRows = rxWrap.querySelectorAll('[data-bb-rx-opt]');
        // Anti-Fog coating toggle — swaps the picked row's variant for its
        // "+ Anti-Fog" counterpart on commit (rows carry data-af-*).
        var rxAf = rxWrap.querySelector('[data-bb-rx-af]');
        var rxAfInput = rxWrap.querySelector('[data-bb-rx-af-input]');
        var rxAfPrice = rxWrap.querySelector('[data-bb-rx-af-price]');
        var rxPick = null;   // row highlighted inside the dialog (uncommitted)
        var rxOpened = false;
        var rxSyncRows = function () {
          rxRows.forEach(function (r) {
            var on = r === rxPick;
            r.setAttribute('aria-pressed', on ? 'true' : 'false');
            r.classList.toggle('is-selected', on);
          });
          rxAdd.disabled = !rxPick;
          rxAdd.setAttribute('aria-disabled', rxPick ? 'false' : 'true');
          if (rxRemove) rxRemove.hidden = !rxSelected;
          if (rxAf) {
            var afOk = !!(rxPick && rxPick.dataset.afVariant);
            rxAf.hidden = !afOk;
            if (!afOk && rxAfInput) rxAfInput.checked = false;
            if (afOk && rxAfPrice) rxAfPrice.textContent = '+' + rxPick.dataset.afDelta;
          }
        };
        var rxCommit = function (row) {
          var useAf = !!(row && rxAfInput && rxAfInput.checked && row.dataset.afVariant);
          rxSelected = row ? (useAf ? row.dataset.afVariant : row.dataset.variant) : null;
          rxCents = row ? (parseInt(useAf ? row.dataset.afPrice : row.dataset.price, 10) || 0) : 0;
          rxWrap.classList.toggle('has-rx', !!row);
          rxLabel.textContent = row ? (useAf ? row.dataset.afName : row.dataset.name) : '';
          updatePrices();
          if (row && window.apexxTrack) apexxTrack('addon_select', { group: 'prescription', item: (useAf ? row.dataset.afName : row.dataset.name), on: true });
        };
        rxToggle.addEventListener('click', function () {
          rxPick = null;
          rxRows.forEach(function (r) { if (r.dataset.variant === rxSelected || (r.dataset.afVariant && r.dataset.afVariant === rxSelected)) rxPick = r; });
          if (rxAfInput) rxAfInput.checked = !!(rxPick && rxPick.dataset.afVariant && rxPick.dataset.afVariant === rxSelected);
          rxSyncRows();
          if (typeof rxModal.showModal !== 'function') return;
          rxModal.showModal();
          if (!rxOpened) {
            rxOpened = true;
            if (window.apexxTrack) apexxTrack('prescription_opened', { source: 'bundle_bb' });
          }
        });
        rxWrap.querySelectorAll('[data-bb-rx-close]').forEach(function (x) {
          x.addEventListener('click', function () { rxModal.close(); });
        });
        rxModal.addEventListener('click', function (e) {
          if (e.target === rxModal) rxModal.close(); // backdrop tap
        });
        rxRows.forEach(function (row) {
          row.addEventListener('click', function (e) {
            if (e.target.closest('[data-bb-rx-info]')) return;
            rxPick = (rxPick === row) ? null : row;
            rxSyncRows();
          });
        });
        rxWrap.querySelectorAll('[data-bb-rx-info]').forEach(function (ic) {
          ic.addEventListener('click', function (e) {
            e.stopPropagation();
            var wrap = ic.closest('.pca__rx-row-wrap');
            var tip = wrap && wrap.querySelector('[data-bb-rx-tip]');
            if (tip) tip.hidden = !tip.hidden;
          });
        });
        rxAdd.addEventListener('click', function () {
          if (!rxPick) return;
          rxCommit(rxPick);
          rxModal.close();
        });
        if (rxRemove) rxRemove.addEventListener('click', function () {
          rxPick = null;
          rxCommit(null);
          rxSyncRows();
          rxModal.close();
        });
      }
      // During an offer that gives the standard insert away, an upgrade tier is
      // two lines: the free standard (zeroed by the automatic discount) plus a
      // delta-priced upgrade SKU. Without the upgrade line the shopper would be
      // charged the tier's full shelf price while the picker showed the delta.
      // No upgrade id published (offer off, or product unpublished) → one line,
      // exactly as before.
      function rxItems() {
        if (!rxSelected) return [];
        var row = rxWrap && rxWrap.querySelector('[data-bb-rx-opt][data-variant="' + rxSelected + '"]');
        var freeId = row && row.getAttribute('data-offer-free-variant');
        // Anti-fog is its own variant, so it carries its own upgrade SKU; pick
        // whichever matches what is actually selected.
        var afOn = row && row.getAttribute('data-af-variant') === String(rxSelected);
        var upgId = row && row.getAttribute(afOn ? 'data-af-upgrade-variant' : 'data-offer-upgrade-variant');
        if (freeId && upgId && String(freeId) !== String(rxSelected)) {
          return [{ id: parseInt(freeId, 10), quantity: 1 },
                  { id: parseInt(upgId, 10), quantity: 1 }];
        }
        return [{ id: parseInt(rxSelected, 10), quantity: 1 }];
      }
      function rxItem() {
        var it = rxItems();
        return it.length ? it[0] : null;
      }

      // "Add Photochromic Lens" tiles — single-select toggle, Core-picker look.
      // Hero swap — mirrors the Core picker's applyHero: overlay the Files
      // photo onto the active gallery image + first thumbnail + lightbox,
      // and restore the originals on deselect.
      var bbHeroStore = [];
      function bbHeroTargets() {
        var targets = [];
        var mains = document.querySelectorAll(
          '.product__media-wrapper .product__media-item.is-active img,' +
          '.product__media-wrapper .product__media-item--single img');
        var main = null;
        for (var i = 0; i < mains.length; i++) { if (mains[i].offsetParent !== null) { main = mains[i]; break; } }
        if (!main) main = mains[0] || document.querySelector('.product__media-wrapper .product__media img');
        if (main) targets.push(main);
        var thumbs = document.querySelectorAll('.thumbnail-list .thumbnail-list__item:first-child img');
        Array.prototype.forEach.call(thumbs, function (t) { targets.push(t); });
        var modalImg = document.querySelector('.product-media-modal__content .product__media img')
                    || document.querySelector('.product-media-modal__content img');
        if (modalImg) targets.push(modalImg);
        return targets;
      }
      function bbApplyHero(url) {
        if (url) url = url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=1600';
        if (!bbHeroStore.length || !bbHeroStore[0].img.isConnected) {
          bbHeroStore = bbHeroTargets().map(function (img) {
            return { img: img, src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), fit: img.style.objectFit };
          });
        }
        bbHeroStore.forEach(function (st) {
          var img = st.img;
          if (url) {
            img.setAttribute('srcset', url);
            img.setAttribute('src', url);
            img.style.objectFit = 'contain';
          } else {
            if (st.srcset != null) img.setAttribute('srcset', st.srcset); else img.removeAttribute('srcset');
            img.setAttribute('src', st.src);
            img.style.objectFit = st.fit || '';
          }
        });
      }

      // "Includes" strip lens count — an added photochromic lens makes it 4 Lenses.
      var incLine = bb.querySelector('.apexx-bb__incstrip-line');
      var incBase = incLine ? incLine.textContent : '';
      function updateIncludes() {
        if (!incLine) return;
        var add = photoSelected ? 1 : 0;
        incLine.textContent = incBase.replace(/(\d+)(\s*Lens)/i, function (m, n, word) {
          return (parseInt(n, 10) + add) + word;
        });
      }

      var photoWrap = bb.querySelector('[data-bb-photo]');
      if (photoWrap) {
        var photoOpts = photoWrap.querySelectorAll('[data-bb-photo-opt]');
        var photoToggle = photoWrap.querySelector('[data-bb-photo-toggle]');
        var photoPanel = photoWrap.querySelector('[data-bb-photo-panel]');
        var photoLabel = photoWrap.querySelector('[data-bb-photo-label]');
        if (photoToggle && photoPanel) {
          photoToggle.addEventListener('click', function () {
            var open = photoPanel.hidden;
            photoPanel.hidden = !open;
            photoWrap.classList.toggle('is-open', open);
            photoToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          });
        }
        photoOpts.forEach(function (o) {
          o.addEventListener('click', function () {
            photoSelected = (photoSelected === o) ? null : o;
            photoOpts.forEach(function (x) {
              var on = x === photoSelected;
              x.setAttribute('aria-pressed', on ? 'true' : 'false');
              x.classList.toggle('is-selected', on);
            });
            photoWrap.classList.toggle('has-rx', !!photoSelected);
            bbApplyHero(photoSelected ? (photoSelected.dataset.hero || '') : '');
            if (photoLabel) photoLabel.textContent = photoSelected ? photoSelected.dataset.name : '';
            updatePrices();
            updateIncludes();
            if (photoSelected && window.apexxTrack) apexxTrack('addon_select', { group: 'photochromic', item: photoSelected.dataset.name, on: true });
          });
        });
      }
      function photoItem() {
        return photoSelected ? { id: parseInt(photoSelected.dataset.variant, 10), quantity: 1 } : null;
      }
      // Everything that rides along with the bundle at full price.
      function addonItems() {
        return rxItems().concat([photoItem()]).filter(Boolean);
      }

      // No trial toggle on this card → native submit; add the add-ons first.
      if ((rxWrap || photoWrap) && form && !bb.querySelector('[data-bb-payopts]')) {
        form.addEventListener('submit', function (e) {
          var adds = addonItems();
          if (!adds.length || !form.getAttribute('action') || form.dataset.bbSubmitting) return;
          e.preventDefault();
          form.dataset.bbSubmitting = '1';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: adds })
          }).finally(function () { delete form.dataset.bbSubmitting; form.submit(); });
        });
      }

      // Try-it-First trial toggle (bundles): choosing the trial enables the
      // hidden selling_plan input (that's what attaches the plan at
      // /cart/add) and restyles the CTA; back to full price disables it.
      var payopts = bb.querySelector('[data-bb-payopts]');
      var planInput = bb.querySelector('[data-bb-selling-plan]');

      // Voucher note: shown only to a buyer holding one of OUR codes, with the
      // trial tile selected. An ambassador or Collabs code survives a trial, so
      // showing it there would be telling them something untrue about their own
      // code. Ours are identified exactly: the house codes are published to the
      // shop metafield apexx.pay_in_full_codes (read below), and minted vouchers
      // — which are created continuously, so no static list can hold them — are
      // confirmed by the same Control Tower lookup the strip itself uses.
      var codeNote = bb.querySelector('[data-bb-codenote]');
      var codeInPlay = false;
      function paintCodeNote(trial) {
        if (codeNote) codeNote.hidden = !(trial && codeInPlay);
      }
      function trialTileOn() {
        var on = payopts ? payopts.querySelector('[data-bb-payopt].is-on') : null;
        return !on || on.getAttribute('data-bb-payopt') === 'trial';
      }
      if (codeNote && bb.getAttribute('data-codes-pif') === '1') {
        var houseCodes = (bb.getAttribute('data-pif-codes') || '')
          .split(',')
          .map(function (c) { return c.trim().toUpperCase(); })
          .filter(Boolean);
        var seen = [];
        try {
          var stashed = (sessionStorage.getItem('apexxDiscountCode') || '').trim();
          if (stashed) seen.push(stashed.toUpperCase());
        } catch (e) {}
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            (cart.discount_codes || []).forEach(function (d) {
              if (d.code) seen.push(String(d.code).toUpperCase());
            });
            if (!seen.length) return;
            if (seen.some(function (c) { return houseCodes.indexOf(c) !== -1; })) {
              codeInPlay = true;
              paintCodeNote(trialTileOn());
              return;
            }
            // Not a known house code — ask whether Control Tower minted it.
            // No answer means no note: a silent note is better than telling an
            // ambassador their code won't work when it would.
            var host = bb.getAttribute('data-ct-host') || 'https://pay.apexxseries.com';
            return fetch(host + '/api/discount/minted?codes=' + encodeURIComponent(seen.join(',')), {
              headers: { 'Accept': 'application/json' },
            })
              .then(function (m) { return m.ok ? m.json() : null; })
              .then(function (res) {
                if (res && (res.minted || []).length) {
                  codeInPlay = true;
                  paintCodeNote(trialTileOn());
                }
              });
          })
          .catch(function () {});
      }

      if (payopts && planInput && btn) {
        var mainEl = btn.querySelector('.apexx-bb__btn-main');
        var subEl = btn.querySelector('.apexx-bb__btn-sub');
        var depositLabel = payopts.getAttribute('data-deposit-label') || '';
        var fullMain = payopts.getAttribute('data-full-main') || '';
        var fullSub = payopts.getAttribute('data-full-sub') || '';
        payopts.querySelectorAll('[data-bb-payopt]').forEach(function (opt) {
          opt.addEventListener('click', function () {
            var trial = opt.getAttribute('data-bb-payopt') === 'trial';
            payopts.querySelectorAll('[data-bb-payopt]').forEach(function (o) {
              var on = o === opt;
              o.classList.toggle('is-on', on);
              o.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            planInput.disabled = !trial;
            paintCodeNote(trial);
            var planMain = payopts.getAttribute('data-plan-main') || '';
            var planSub = payopts.getAttribute('data-plan-sub') || '';
            if (mainEl) mainEl.textContent = trial ? planMain : fullMain;
            if (subEl) subEl.textContent = trial ? planSub : fullSub;
            updatePrices();
            emitPayoptState();
          });
        });

        // Tell the sticky ATC bar which pay option is selected so its label
        // and price mirror the buy box (trial deposit vs pay-in-full). The
        // [data-bb-dep]/[data-bb-price] spans are kept live by updatePrices()
        // (they include photochromic/rx add-ons), so read them at emit time —
        // and re-emit whenever they change.
        function emitPayoptState() {
          var on = payopts.querySelector('[data-bb-payopt].is-on');
          var isTrial = !!on && on.getAttribute('data-bb-payopt') === 'trial';
          var depEl = bb.querySelector('[data-bb-dep]');
          var depText = ((depEl && depEl.textContent) || depositLabel || '').trim();
          var priceEl = bb.querySelector('[data-bb-price]');
          var fullText = ((priceEl && priceEl.textContent) || '').trim();
          document.dispatchEvent(new CustomEvent('purchase-option:changed', {
            detail: {
              poType: isTrial ? 'trial' : 'full',
              btnLabel: isTrial
                ? (payopts.getAttribute('data-plan-main') || '')
                : (fullMain || ''),
              price: isTrial && depText ? depText + ' today' : fullText,
              deposit: depText,
              full: fullText
            }
          }));
        }
        if (window.MutationObserver) {
          var poWatch = new MutationObserver(function () { emitPayoptState(); });
          var depWatchEl = bb.querySelector('[data-bb-dep]');
          if (depWatchEl) poWatch.observe(depWatchEl, { childList: true, characterData: true, subtree: true });
          priceEls.forEach(function (el) {
            poWatch.observe(el, { childList: true, characterData: true, subtree: true });
          });
        }
        emitPayoptState();

        // Trial-only pages: the tiles above are hidden and the CTA opens a
        // confirm step instead of submitting. Pay in full exists only inside
        // that step. Each choice is routed back through the (hidden) tile click
        // and the ordinary submit below, so add-ons, tracking and the sticky
        // bar behave exactly as they do on the normal page. Registered before
        // the submit handler below so it can stop it.
        var gate = bb.querySelector('[data-bb-trialgate]');
        if (gate && typeof gate.showModal === 'function') {
          form.addEventListener('submit', function (e) {
            if (!form.getAttribute('action') || form.dataset.bbGateOk) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            // The sticky bar spins on click expecting a cart add; nothing is
            // being added yet, so release it.
            document.querySelectorAll('.sticky-atc-bar .is-loading').forEach(function (el) { el.classList.remove('is-loading'); });
            gate.showModal();
            if (window.apexxTrack) apexxTrack('trial_gate_open', {});
          });
          gate.addEventListener('click', function (e) { if (e.target === gate) gate.close(); });
          gate.querySelectorAll('[data-bb-gate-close]').forEach(function (x) {
            x.addEventListener('click', function () { gate.close(); });
          });
          gate.querySelectorAll('[data-bb-gate-go]').forEach(function (go) {
            go.addEventListener('click', function () {
              var choice = go.getAttribute('data-bb-gate-go');
              var tile = payopts.querySelector('[data-bb-payopt="' + choice + '"]');
              if (tile) tile.click();
              if (window.apexxTrack) apexxTrack('trial_gate_choice', { choice: choice });
              gate.close();
              form.dataset.bbGateOk = '1';
              if (typeof form.requestSubmit === 'function') form.requestSubmit(btn); else btn.click();
              // One pass only. If the submit navigated away this never runs; if
              // it didn't (preview, or a failed add), the next click asks again.
              setTimeout(function () { delete form.dataset.bbGateOk; }, 1500);
            });
          });
        }

        // Trial selected → add then go straight to checkout. Pay in Full stays
        // on the normal /cart/add flow (the insert, if chosen, is added first).
        form.addEventListener('submit', function (e) {
          if (!form.getAttribute('action')) return;     // preview → let toast handler run
          if (form.dataset.bbSubmitting) return;
          var adds = addonItems();
          if (planInput.disabled) {                     // Pay in Full
            if (!adds.length) return;                   // → unchanged native flow
            e.preventDefault();
            form.dataset.bbSubmitting = '1';
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: adds })
            }).finally(function () { delete form.dataset.bbSubmitting; form.submit(); });
            return;
          }
          e.preventDefault();
          form.dataset.bbSubmitting = '1';
          btn.classList.add('is-loading');
          var payload, headers = { 'Accept': 'application/json' };
          if (adds.length) {
            // One atomic add: add-ons (full price) + bundle (with trial plan).
            var mainItem = { id: parseInt(idInput.value, 10), quantity: 1 };
            if (planInput.value) mainItem.selling_plan = parseInt(planInput.value, 10);
            headers['Content-Type'] = 'application/json';
            payload = JSON.stringify({ items: adds.concat([mainItem]) });
          } else {
            payload = new FormData(form);
          }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: headers,
            body: payload
          })
            .then(function (r) {
              if (!r.ok) throw new Error('add failed');
              // APEXX voucher codes are for Pay in Full only. A code pre-applied
              // by a /discount/CODE link (the draw emails) would otherwise ride
              // the deposit plan and knock 25% off the day-30 balance — #5451.
              // Shopify's purchase-type flag does not exclude try-before-you-buy,
              // so OUR codes are removed from the cart here before checkout.
              // Only ours: Control Tower says which of the applied codes it
              // minted, and every other code (ambassador, wholesale, promo) is
              // kept. If that lookup fails, nothing is removed — wrongly
              // stripping someone else's code is the worse failure.
              // Master switch: Settings -> Custom data -> Shop ->
              // "Discount codes: Pay in Full only". Unticked and nothing is
              // stripped, same as before this rule existed.
              if (bb.getAttribute('data-codes-pif') !== '1') return;
              return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
                .then(function (c) { return c.json(); })
                .then(function (cart) {
                  var codes = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(Boolean);
                  if (!codes.length) return;
                  var host = (bb.getAttribute('data-ct-host') || 'https://pay.apexxseries.com');
                  return fetch(host + '/api/discount/minted?codes=' + encodeURIComponent(codes.join(',')), { headers: { 'Accept': 'application/json' } })
                    .then(function (m) { return m.ok ? m.json() : null; })
                    .then(function (res) {
                      var ours = (res && res.minted) || [];
                      if (!ours.length) return;
                      var keep = codes.filter(function (c) { return ours.indexOf(c.toUpperCase()) === -1; });
                      return fetch('/cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: JSON.stringify({ discount: keep.join(',') })
                      });
                    });
                })
                .catch(function () {});
            })
            .then(function () {
              if (window.apexxTrack) apexxTrack('checkout_redirect', { path: 'buybox_trial', tier: 'trial' });
              window.location.href = '/checkout';
            })
            .catch(function () {
              // Fallback: let the browser do the normal cart/add navigation.
              delete form.dataset.bbSubmitting;
              form.submit();
            });
        });
      }

      // submit feedback (don't block real /cart/add navigation in theme;
      // in preview there is no action so we show a toast state)
      if (form && btn) {
        form.addEventListener('submit', function (e) {
          if (!form.getAttribute('action')) {
            e.preventDefault();
            var html = btn.innerHTML;
            btn.innerHTML = 'Added \u2713';
            btn.style.background = '#258A4B';
            setTimeout(function () { btn.innerHTML = html; btn.style.background = ''; }, 1300);
          }
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () { bind(document); });
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
